import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ApplicationInformationDetails from './AppicationInformationDetails';
import DocumentsDetails from './DocumentsDetails';
import HouseholdIncomeDetails from './HouseholdIncomeDetails';
import Scope from './Scope';

export const CRApplicationDetails = ({ applicationData, files }: IApplicationDetails) => {
  return (
    <>
      <ApplicationInformationDetails applicationInformation={applicationData.application} />
      <HouseholdIncomeDetails householdIncome={applicationData?.householdIncome} />
      <DocumentsDetails documents={applicationData?.documents} files={files} />
      <Scope scope={applicationData.scope} />
    </>
  );
};
